var frontpage_slider = ( function ( $ ) {

	var $carousel      = null,
		added_script   = false,
		api_loaded     = false,
		playing_vid_id = false,
		videos         = {},
		continue_playing_timeout;

	window.onYouTubeIframeAPIReady = function() {
		api_loaded = true;
	};

	var _init = function () {
		$carousel = $( '#hero-slider' ).find( '.owl-carousel' );

		_setup_slider();

		if ( $carousel.find( '.youtube-video' ).length > 0 ) {
			_load_youtube_api_script();
		}
	};

	var _setup_slider = function () {
		$carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$carousel.owlCarousel( {
			items: 1,
			loop: true,
			animateOut: 'fadeOut',
			mouseDrag: false,
			touchDrag: false,
			freeDrag: false,
			autoplayTimeout: 7000
		} );
	};

	var _setup_video = function( property ) {
		var current     = property.item.index,
			$slide_elem = $( property.target ).find( '.owl-item' ).eq( current ),
			$video = $slide_elem.find( '.youtube-video' ),
			player;

		if ( api_loaded ) {
			player = new YT.Player( $video.get(0), {
				height : '390',
				width : '640',
				videoId : $video.data( 'video-id' ),
				events : {
					'onReady' : _player_ready,
					'onStateChange' : _video_changed_state
				}
			} );
		} else {
			// Api isn't ready yet retry
			setTimeout( function() {
				_setup_video( property );
			}, 100 );
		}
	};

	var _get_video_id = function( $video ) {
		return $video.closest( '.slider-video-wrapper' ).attr( 'id' );
	};

	var _add_player_to_obj = function( $video, player ) {
		var vid_id = _make_id( 5 );

		if ( ! ( vid_id in videos ) ) {
			videos[vid_id] = player;
			$video.closest( '.slider-video-wrapper' ).attr( 'id', vid_id );
		} else {
			setTimeout( function() {
				_add_player_to_obj( $video, player );
			}, 10 )
		}
	};

	var _change_playing_video_ref = function( $video ) {
		playing_vid_id = _get_video_id( $video );
	};

	var _player_ready = function( event ) {
		event.target.mute();
		event.target.playVideo();
		$( event.target.a ).addClass( 'ready' );
		$( event.target.a ).addClass( 'played' );

		_add_player_to_obj( $( event.target.a ), event.target );

		_change_playing_video_ref( $( event.target.a ) );
	};

	var _video_changed_state = function( event ) {
		if ( event.data === YT.PlayerState.PAUSED ) {
			playing_vid_id = false;

			continue_playing_timeout = setTimeout( function() {
				_continue_slider( event.target, false )
			}, 4000 );
		}

		if ( event.data === YT.PlayerState.PLAYING ) {
			clearTimeout( continue_playing_timeout );
			_stop_autoplay();
			_change_playing_video_ref( $( event.target.a ) )
		}

		if ( event.data === YT.PlayerState.ENDED  ) {
			clearTimeout( continue_playing_timeout );
			_continue_slider( event.target );
		}
	};

	var _continue_slider = function( player, reset ) {
		if ( reset === undefined ) {
			reset = true;
		}

		$carousel.trigger( 'next.owl.carousel' );

		if ( reset ) {
			_reset_video( player );
		} else  {
			playing_vid_id = false;
			_start_autoplay();
		}
	};

	var _reset_video = function( video_id ) {
		if ( ! videos[video_id] ) {
			return
		}

		var player = videos[video_id];

		player.seekTo(0);
		player.stopVideo();
		$( player.a ).addClass( 'played' );

		playing_vid_id = false;
	};

	var _slider_initialised = function( property ) {
		$carousel.find( '.owl-item .item' ).show();
		$carousel.on( 'changed.owl.carousel', _slide_changed );

		if ( ! _current_slide_has_video( property ) ) {
			_start_autoplay();
		} else {
			_setup_video( property );
		}
	};

	var _slide_changed = function( property ) {
		if ( _current_slide_has_video( property ) ) {
			_stop_autoplay();
			_setup_video( property );

			if ( _has_video_been_played( property ) ) {
				_start_autoplay();
			}
		}

		// Video is playing and slide has changed
		if ( playing_vid_id ) {
			_reset_video( playing_vid_id );

			// Stops slide jumping to fast
			_stop_autoplay();

			// Timeout needed to prevent autoplay not firing
			setTimeout( _start_autoplay, 1000 );
		} else {

			// No video on next slide so autoplay as normal
			_start_autoplay();
		}
	};

	var _has_video_been_played = function( property ) {
		var current     = property.item.index,
			$slide_elem = $( property.target ).find( '.owl-item' ).eq( current );

		return $slide_elem.find( '.slider-video-wrapper iframe' ).hasClass( 'played' );
	};

	var _current_slide_has_video = function( property ) {
		var current     = property.item.index,
			$slide_elem = $( property.target ).find( '.owl-item' ).eq( current );

		return $slide_elem.find( '.item' ).hasClass( 'has-video' );
	};

	// Similar to above function but doesn't require to pass property
	var _slider_current_slide_has_video = function( slide_index ) {
		var current = slide_index,
			$slide_elem = $carousel.find( '.owl-item' ).eq( current );

		return $slide_elem.find( '.item' ).hasClass( 'has-video' );
	};

	var _stop_autoplay = function() {
		$carousel.trigger( 'stop.owl.autoplay' );
	};

	var _start_autoplay = function() {
		$carousel.trigger( 'play.owl.autoplay' );
	};

	var _load_youtube_api_script = function() {
		if ( ! added_script ) {
			var tag = document.createElement( 'script' ),
				first_script_tag = document.getElementsByTagName( 'script' )[0];

			tag.id = 'youtube-iframe-api';
			tag.src = 'https://www.youtube.com/iframe_api';

			first_script_tag.parentNode.insertBefore( tag, first_script_tag );
		}
	};

	var _make_id = function( length ) {
		var text = '';
		var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		for ( var i = 0; i < length; i++ ) {
			text += possible.charAt( Math.floor( Math.random() * possible.length ) );
		}

		return text;
	};

	if ( $( '#fp-slider' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = frontpage_slider;